var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{staticClass:"font-weight-bold my-0",attrs:{"color":"white"}},[_c('v-icon',{staticClass:"mr-2 mb-1",attrs:{"color":"primary"}},[_vm._v("fas fa-times-circle")]),_c('span',{staticClass:"table-no-results-text"},[_vm._v(_vm._s(_vm.$t(_vm.message)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }